import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import { useDispatch } from "react-redux";
// import EditIcon from "@material-ui/icons/Edit";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Autocomplete2 from "../../Utils/GenericUI/Select";
import {
  submitCampaignOwner,
  loadCampaignOwnerNames,
} from "../../Redux/Actions/webAppActions";
import { DataValidation } from "../../Utils/StaticData/Constant";
const CampaignOwerPopup = ({
  customerId,
  campaignOwnerNamesList,
  resetCampaign,
}) => {
  const dispatch = useDispatch();
  const [owner, setOwner] = useState({
    label: "",
    value: "",
  });
  const [snackbar, setSnackbar] = useState({
    snackBarOpen: false,
    vertical: "top",
    horizontal: "center",
    snackBarSeverty: "",
    snackBarMsg: "",
  });
  const [ownerName, setOwnerName] = useState("");
  const handleDropdown = (event) => {
    setOwner({ label: event.label, value: event.value });
    console.log("working in this", event);
  };
  const submitData = async () => {
    if (ownerName === "") {
      setSnackbar({
        ...snackbar,
        snackBarOpen: true,
        snackBarMsg: "Please fill Campaign owner first.",
        snackBarSeverty: "error",
      });
    } else {
      const payload = { campaignOwnerId: "", campaignOwnerName: ownerName };
      const response = await dispatch(submitCampaignOwner(payload));
      if (response.status === "OK") {
        setOwnerName("");
        await dispatch(loadCampaignOwnerNames());
        setSnackbar({
          ...snackbar,
          snackBarOpen: true,
          snackBarMsg: "Campaign owner added successfully.",
          snackBarSeverty: "success",
        });
      }
    }
  };
  const handleClose = (event, reason) => {
    setSnackbar({ ...snackbar, snackBarOpen: false });
    if (reason === "clickaway") {
      return;
    }
  };
  const { vertical, horizontal, snackBarOpen, snackBarSeverty, snackBarMsg } =
    snackbar;
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={snackBarOpen}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={snackBarSeverty}>
          {snackBarMsg}
        </Alert>
      </Snackbar>
      <div
        id="campaignOwnerModal"
        class="modal fade z-index-1051"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable ">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Campaign Owner</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => {
                  setOwner({ label: "", value: "" });
                  setOwnerName("");
                }}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="panel-body campaignsingle">
                <div className="form-panel2">
                  <div className="row">
                    <span className="col-lg-4 col-md-6 col-sm-12 mb-2 campaignOwner">
                      <label className="labelcampaign" htmlFor="campaignOwner">
                        List of Campaign Owner
                      </label>
                      <br />
                      <Autocomplete2
                        //   error={
                        //     customerId === "HCF0450"
                        //       ? adminList?.some((x) => x.label === campaignOwner)
                        //         ? false
                        //         : true
                        //       : prospectagentList.some(
                        //           (x) => x.label === campaignOwner
                        //         )
                        //       ? false
                        //       : true
                        //   }
                        handleChange={(e) => handleDropdown(e)}
                        options={campaignOwnerNamesList}
                        value={owner}
                        //  name="campaignOwner"

                        // label="Campaign owner *"
                        //   disabled={
                        //     this.state.enrlCampaignId == ""
                        //       ? false
                        //       : !this.state.editFormCssInd
                        //   }
                        //  defaultValue={this.props?.prospectagentList?.find(
                        //    (data) => data?.value === this.state.campaignOwner
                        //  )}
                        //  margin="20px auto"
                        width="100%"
                        show={true}
                      />
                    </span>
                    <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                      <span className="label-container">
                        <label
                          className="labelcampaign"
                          htmlFor="planCampaignName"
                        >
                          Add Campaign owner
                        </label>
                        <br />
                        <TextField
                          name="planCampaignName"
                          // error={
                          //   this.state.planCampaignName === "" ? true : false
                          // }
                          //  value={this.state.planCampaignName}
                          size="small"
                          // className="campaignwidth10"
                          className="prospectwidth9"
                          onChange={(event) => {
                            if (
                              event.target.value !== "" &&
                              !DataValidation.test(event.target.value)
                            ) {
                              return;
                            }
                            setOwnerName(event.target.value);
                          }}
                          // label="Campaign Name*"
                          variant="outlined"
                          value={ownerName}
                          inputProps={{
                            maxLength: 20,
                            autoComplete: "off",
                            spellcheck: "false",
                            "aria-autocomplete": "both",
                            "aria-haspopup": "false",
                          }}
                        />
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                id="submit"
                className="btn btn-dashboard-active"
                onClick={() => submitData()}
              >
                {" "}
                Add{" "}
              </button>
              <button
                className="btn btn-campaign"
                data-dismiss="modal"
                onClick={() => {
                  setOwner({ label: "", value: "" });
                  setOwnerName("");
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CampaignOwerPopup;
